export default __webpack_public_path__ + "static/code_blooded-84e94b09737aaa0703bdc5726b904b87.svg";